module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'wasteTypeCreate',
        params: {
          _id: '0'
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn gradientbt"
  }, [_vm._v("Add Waste Type")])])], 1), _vm._v(" "), (_vm.updateCategoryDetails) ? _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('div', {}), _vm._v(" "), _c('div', {
    staticClass: "overlay waste_type_pop",
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "overlay_inner"
  }, [_c('div', {
    staticClass: "row form-modal"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    }
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Update " + _vm._s(this.rows.wCName))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.categoryUpdate),
    attrs: {
      "auto-label": ""
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.category.categoryUpdate),
      expression: "category.categoryUpdate"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "type": "text",
      "name": "categoryUpdate",
      "placeholder": "Category (Dry, Wet, E-Waste etc.) ",
      "pattern": "^[a-zA-Z][a-zA-Z0-9\\s]{0,25}"
    },
    domProps: {
      "value": (_vm.category.categoryUpdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.category, "categoryUpdate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "categoryUpdate",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                                                        Category is a required field\n                                                    ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                                                        Alphabets/Numbers are allowed.\n                                                    ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [_c('button', {
    class: 'mr-2 btn gradientbt',
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateWasteType
    }
  }, [_vm._v("\n                                            Update\n                                        ")]), _vm._v(" "), _c('button', {
    class: 'mr-5  btn btn-default',
    on: {
      "click": _vm.onClose
    }
  }, [_vm._v("\n                                            Cancel\n                                        ")])])], 1)])])])])]) : _vm._e(), _vm._v(" "), _c('v-server-table', {
    ref: "wasteTypeTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "wCName",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp",
          staticStyle: {
            "display": "flex",
            "justify-content": "space-between"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.wCName) + "\n\n                        "), _c('a', {
          staticClass: "fa fa-pencil",
          staticStyle: {
            "flex": "inherit"
          },
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.editCategory(props.row); }).apply(null, arguments)
            }
          }
        })])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "role": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.action(props.row)
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "py-2 text-center row"
        }, [_c('label', {
          staticClass: "toggle"
        }, [_c('input', {
          staticClass: "toggle-checkbox",
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": props.row.status
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return (function (e) { return _vm.activateWasteTypeModal(props.row); }).apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('span', {
          staticClass: "slider"
        }), _vm._v(" "), _c('span', {
          staticClass: "labels",
          attrs: {
            "data-on": "Active",
            "data-off": "Deactivate"
          }
        })])])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-319def8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/wasteType/wasteType.vue
// module id = 2304
// module chunks = 1